module.exports = __webpack_public_path__ + "img/auth-chat.1aacace5.svg";